function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.1009 61.5916C45.6617 57.9653 38.0522 57.0248 30.924 58.9742C23.7959 60.9236 17.7241 65.6056 14.0266 72.004L13.3313 73.2705C5.82935 87.016 4.00027 103.15 8.23484 118.227C12.4694 133.303 22.4318 146.125 35.9938 153.955L80.0275 77.6903L52.1009 61.5833V61.5916Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.0252 93.8056C17.6637 97.5727 13.0453 103.697 11.1732 110.849C9.30103 118.002 10.3264 125.603 14.0266 132.004L14.7715 133.237C22.9299 146.602 35.9899 156.246 51.1625 160.113C66.3353 163.979 82.4182 161.76 95.9772 153.93L51.9434 77.6656L24.0501 93.7725L24.0252 93.8056Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.8808 134.214C37.9572 141.608 40.9476 148.674 46.2026 153.877C51.4579 159.079 58.5532 161.998 65.9481 162L67.3965 161.959C83.0491 161.583 97.9341 155.1 108.872 143.897C119.809 132.694 125.932 117.657 125.932 102H37.8724V134.214H37.8808Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M79.8039 142.408C86.2428 146.035 93.8523 146.975 100.98 145.026C108.109 143.076 114.18 138.394 117.878 131.996L118.573 130.729C126.078 116.99 127.915 100.862 123.691 85.7871C119.468 70.7124 109.519 57.8857 95.9688 50.0453L51.9351 126.31L79.837 142.417L79.8039 142.408Z",
  fill: "url(#paint3_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M94.0238 69.786C93.9474 62.3901 90.9558 55.3232 85.6989 50.1205C80.4419 44.9178 73.3444 41.9996 65.9483 42L64.5081 42.0414C54.287 42.2826 44.2974 45.1341 35.4889 50.3249C26.6808 55.5157 19.3466 62.8732 14.1838 71.6978C17.9308 65.3936 23.9964 60.8063 31.0828 58.9175C38.169 57.0288 45.7132 57.9886 52.1008 61.5917L65.9399 69.5789L94.0238 85.7938V102V69.786Z",
  fill: "url(#paint4_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M117.903 71.9959L117.15 70.7626C111.833 62.0412 104.378 54.8222 95.4899 49.79C86.6017 44.7578 76.5755 42.0793 66.3618 42.0083C73.6847 42.1159 80.6757 45.0806 85.8436 50.27C91.0113 55.4594 93.9467 62.4627 94.0235 69.786V102V118.206L87.4019 122.014L107.854 110.202C114.225 106.442 118.854 100.32 120.735 93.1656C122.617 86.0114 121.599 78.4037 117.903 71.9959Z",
  fill: "url(#paint5_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M106.729 56.4764H24.7869V147.524H106.729V56.4764Z",
  fill: "url(#pattern0)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M65.9399 101.992V134.413L94.0238 118.207V85.7854L65.9399 101.992Z",
  fill: "url(#paint6_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M65.9401 101.992V134.413L37.8644 118.207V85.7854L65.9401 101.992Z",
  fill: "url(#paint7_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M94.0239 85.7853L65.9401 101.992L37.8644 85.7853L65.9401 69.5707L94.0239 85.7853Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M110.04 58.132H21.4758V145.868H110.04V58.132Z",
  fill: "url(#pattern1)"
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0",
  transform: "scale(0.010101 0.00909091)"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern1",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image1",
  transform: "scale(0.00934579)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 41.9698,
  y1: 119.68,
  x2: 45.6943,
  y2: 8.39534,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AEEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00679E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 15419.1,
  y1: 28816.3,
  x2: 16680.8,
  y2: 17865.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AEEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00679E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 124.872,
  y1: 100.734,
  x2: -39.7162,
  y2: 178.405,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AEEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#008FCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00679E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 19060.5,
  y1: 23080.1,
  x2: 10384.9,
  y2: 36522.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AEEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00679E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 11040.9,
  y1: 14613.6,
  x2: 30323.5,
  y2: 14913.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AEEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00679E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 12781.9,
  y1: 16155.9,
  x2: 13988,
  y2: 32066.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AEEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00679E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 89.074,
  y1: 128.785,
  x2: 76.2695,
  y2: 102.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D4E0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 5070.14,
  y1: 15147.1,
  x2: 5325.74,
  y2: 13208.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D4E0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 65.94,
  y1: 51.7752,
  x2: 65.94,
  y2: 107.703,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 67.0821,
  y1: 82.4333,
  x2: 65.7494,
  y2: 140.521,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#14A5D7",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#14A5D7",
  stopOpacity: 0.3
})), /*#__PURE__*/React.createElement("image", {
  id: "image0",
  width: 99,
  height: 110,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABuCAYAAAAzpa1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAMj0lEQVR4Xu2c63bayhKEC9uJnb33Oe//nifbceIL5wdUKBXVMyPAIFaotWaNELrM9KfqFthitV6vcdMydNfb4Kbz6QZjQXrobbBwrYr1V5l7rw1GFXyXb3cVcK4Bhgc2AeG6FPQ1pvssFsySYWgAV0Xv72uge2AWB2WJMCoI1TL7BGItTUUoiwKyJBgtCL1GJQipcZtFuWQpMNKVznbX6XU/D/rHtq2l5/JKXi8CyqVhuBu83Vm7t9e6LQOpwf8A8C7LbKttr7o4lEvBmAPhPjQF42lKg/4emgPxmnKxenJuGA6BvacfD/6DtHvpCYwiDAb+Tdq79GwO5KL15JwwPL/3nKAAvmzbg/QEwmMAU0e8AXjdNl9+257LU9hF68k5YIympArC123zZXWHwnAQrwB+SVM43FZrC92iOguUz4SRIADTdJRA0AVfpT1K4zoCSzAUwk/pufxre75X7ByiTrlIPfkMGHPqwh12V/gXTEEw+E+hd3cwQApDAbxYr1A0fRHIRerJqWGsQu/pyAu0pyOCeJL2zV4/YgeOxyQMpqBf2AX/x3b5q/Vftu8/IEM5az05FYy5daFKSQqBAP7aLisQpit1BrC7qnnVv2zbEzZAHrEP5gHT1HWxenIsjGPrwhfsAutO+IYNCIVBIHNh/ADwLMd/xvRmgKmLYC5STw6FcUxdeMA0JSUICkKBtJyR0hRTlELg/nQJHaJp6yL15BAYx9QFL86P2AXZnVDB4H6jBZzHJohnOQaPRygJzJx6Qh3kkrkwEoBj6kJKSQkCm97efpHzOAy6gzBeMA2+OkUvDIfi9UQ/NLpLgCNdMgoj1QZNSUxHVV3oQahgVIWbx+V5qTWmMB6xAfJo7SmsU9CteuKf5OkS9ge7ZARGSkteFxRCulXl5L9ZS8H3tJQcoa5IMBTIV2sJTHKK1pMfaNeTN2ziQSBAdkkTSA9GlZbSHVILwlwnuBtaIBwGr9L37bavsl+CUrnE64kCSXddCoSpa5ZDWjASCC/QFQS94lpOUDAO4UmOxWDyfApCUyivRgJ5sJagJDjuEt2Oxf0F+xcFY/SGnYaBjDij5YZ0hzSnJlQQNAAKIYFIMNbb7d6R3ZtuKnpOYXuW/dOYXrHRCjsoDiSqgqETVBjJDQlCBeBve78q0GwOoQLBXmG4ix1KckoLgrtk1KkUiztQuCPBaKUndYRCSGno72J5tC44BE7Y65fKoXCbD2QoVdrqwVB3pbEl+a3uHpBWmnIYCUQCkJrXhgShl5JaIHSSuk7HTyA9p/TA+Fh5HB3TutGoIWcAU3ekOvEVu+Ay4P9YUxCpNoxA4CQdBKRX6Xuc7D123ynxWBWUVE+8uXPdERr4D2t32NSxKIfhV5sOXkEwoITxH2kOREEwrY3WhR6EBETzMnWHaWrwi6xVTxyMOsJBMOjv0vxrE4WmF01ZMxyEDpbWpTP+wQbCfzGF4q5Qq7fqgjrhDhvphPm6kk9W13st0fOMQEkXjYJQCPpPEIwjHTqrZjgQT1EKgynKgagrem7o1QXvR9SDssIuOL16co8aAtMRP4nrn3xft/sRjM5ruGYA+0Acht7Gat1gquJtLF3htWFuXZgDQlVBAcbriadPPaZ+S6x/6v0q63Rf/cwxkcJIk01pyt3hQPwOiq5IIDRNnBqCq4JyJ+u0nqSmVzXdoF/X86+K/Bq+qi2q3y7p1QwdWIKhQFLTuya3uYIA9gd7KgguDbqv03riF4luz/qQ/ojld1w+X21DNQOYB4Rpyz8/aHpKIHSS3n+meI5WPUljoyMI4gnTr+gVhKe3BHUih5ECwgOkwta6J/er4wH7IID9c51TFRRgWhu4zQc2c3rDdI7eGJ+U5mB989aWcmewr4D4QDQttRwBW76EelD43gOm3wanuft8WxffRFXN0GUFoukqOWUuiEtDcPFK1XHdbde15u9tBMTEFUDbGdTKmlvPT54G4g3SL00JSDX3XgzSvEvdNd5LOycwaZD+vh+rO7ALK423dVH6XFsAyrm3YLj04AlINRBfviZVcxhpvl9XFQwPnh6wN8D0Wve7NvkcRuad9kv9RCPOSDu2gnytQZ+r1rx7MYsagXFqdQe1EJ19nMfA6F0Jf5JOEotjYNx0Yp0ShhfsP0EnnfMpYdx0pG4wFqQbjAXpBmNBusFYkG4wFqQbjAXpBmNBusFYkE4Jg//q8ifppHM+JYybjtQxMPSKONnVcaU6SSyOgXGoDh7smXX2cY7ASINqXQlnn8SF1Jp3L2ZRFYx10fs6X65e637XJp/DyLzTfqmfaMQZVDWID3s9OsBrUDWHkeb7ddWCkQ7iJ/yQ3h+XclB+nCUrjTfNvZq3Q/FjRY04ozcIf26tNzgOZqlAdHy9ufdi0QMzUfr3Tt2pGsi7tbfQ+J7/hyG1wu5cJ/vT5RE6ZN7eWkCA/XNM1PpfWx8Qewfwak2B8N/i9W/F7sYlQJkLIs2bc1cwPSATOYw1psHhujWyE/RhQm367/EK4n57LAcE7M57TiBpnsD+xVc9POk/d+QXpKcxBzIBM8cZOjB9fEp/O9YfGdPA8lgO5BKpyyGwT/PlnP0BypdimUA8fenxo6qaMQcEn2XzR8YcxAc253Mg7FWfCSVdna35pocof1jjA5X8cTBPW56uIhSFscb+xNMV4g8V6oP27gifIBu3u8NY6uLyMXI3VBBGQDxv27/b9ox9KA6D53D9HtecNJUGln7CQUH45Lj9O3ZPOLlDVqihHALEIbDn+HycXqCZnhTEvwD+B+A7MhCtJSlVRVUwHETlCn1kjKmG++nV9YaNe3il8Bk4QtFHsFhHjq0nLQgKgoGqCrWnJgb/OzZAFMozdu74JccbqhutzxnVFfML+w8SuhscxCs2z4XTuvpUrLrkA9O0BewHvgelB0HnVY3VC/ULdqnpGZvgKwwCoTu0dqSaAUzHCaC+teWyDvwNmwB5SyDcSWwE8oTd5JnmFIrWE3VKVU+SdOKajugGHae6we8Q6QitE99Do2McRssZk/G30hQnywCvMAWS7pYqCLzS9HX1419z6wnktU9SASSXV7WBaTiBaDXWjDkF/Ld6BZy9AvFAVI5In0X4+ht2QF6xqyf6oHuqJw7EIVApHY2kpMoNCsPvopiaendTB9cMTQGc1Ao7ILptckU1Se0rKL16os7kWDy1+riYZh1Cqg2EwGKdYCiA0c8ZzRQF9NMUl4GpxdKE3fqeotj+kmVPZfztkZF6kurIyLiqAl25wZtD8LkQQnIFNewMle7UguFpwPPwz0bjhOgShUK3pNRV1a4EIo3HIfRAuAvUCQnCcHqiejXD71j8wAoj5eOUrjQQL5g6JUHR9EUo/rMQVAsEA6fn1pTUg9BygqYkhTCUnqgRZ3j9aOXnBIUDrtJWcoluy9vhFhBqjRpElZIqEK2aUEGo3NAFAfRhALVDHIrCqFJEzymVS/znVxVIglGB6KUkBVRB+CXHryBojRgCAYzBAHYHqqCssQlKqh/VXYxCUfunRijVD4r5ZyKeK4Go3MB13Jb76XhbdeEgN6hGYVBV2uI6d4lDeZVGGHNqin5Q9C8nFYYen8dJEConqBt0zCklqRNmu0E1FwaQ05auSzC8qKpLkluSU16wn64SDD32T+ynJgUycofUqwsf2Ehh8PUsHQIDqNMWsBksv8LQ9HW/fe8B01TCIt8q7i9o/wgl6xeDxWOluyZd1pTENgKhSknAfjyGdSgMyqHQIVpLPtCvJ5q6qprCwB0KI90dsek59SJRV580JSUdC4NKTiGY0XqSirwXYE1TvKPiZ42Upph21AVcRwg/UdcFdwJ7SO/LB+tUMCgC8IHOqSde5BkwQvAfLe4VcK1BWovm1IWTp6SkU8MAskuoXj2pXPKITQAfsbm6maIeMP1KRGFUd2yjEBwEQn9SfQYMyqHQIb16oulLXfIT+W/uCUblMELg+9x2tC748kn1mTCo5BSCqeqJXqkM3BdsgOhv5zJFKYwExJd7dQH45JSUdA4YFAH4BKt6okFlMAnAv7nV43kN0uBfvC60dE4YQHYJpelLg6r1RL8c9BQF2S85LDnBQSD0Z9NqvT77OVUayFVod9bu7bVuy4loutFakNJRguDLZ9OlYVCr0CuQVq/7eaqpgn+xutDSUmAA+y5hP9IovcpHmu93UZ27ZrTEgGjK4XoNui9X+7Bf2+vUL0JLcoarcoq/p68rIL7OlxehJcOgqsCndWkyvm6xE74GGKoEYkRXMckl1YwReVArOFcRfNe1wXBdZdAr6VcJN11YNxgL0v8BBWQ5WwLeH1sAAAAASUVORK5CYII="
}), /*#__PURE__*/React.createElement("image", {
  id: "image1",
  width: 107,
  height: 106,
  xlinkHref: "data:image/png;base64,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"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 205,
    viewBox: "0 0 600 205",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M65.9399 102.108L117.903 72.1035C112.635 62.9857 105.06 55.4147 95.9397 50.151C86.8192 44.8873 76.4743 42.1163 65.944 42.1163C55.4138 42.1163 45.0688 44.8873 35.9483 50.151C26.828 55.4147 19.2533 62.9857 13.9851 72.1035L65.9399 102.108Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M65.9399 102L117.903 131.996C112.637 141.116 105.062 148.689 95.9416 153.954C86.8211 159.219 76.4752 161.991 65.944 161.991C55.4126 161.991 45.0669 159.219 35.9462 153.954C26.8257 148.689 19.2515 141.116 13.9851 131.996L65.9399 102Z",
    fill: "url(#paint9_linear)"
  }), _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.f58d1010.svg";
export { ForwardRef as ReactComponent };